<div
	[class.dark-theme]="true"
	class="fix-action-dialog2"
	style="background-color: #101727; margin: 12px"
	[style.backgroundColor]="
		view_mode == 'advice' ? '#101727' : 'rgb(36,36,36)'
	"
	(window:resize)="onResize($event)"
	[attr.rendertime]="renderTime"
>
	<h3
		*ngIf="view_mode == 'memo'"
		data-idtest="description-dialog-t-9Kh"
		class="dialog_title"
		mat-dialog-title
		style="
			padding: 16px 0px;
			display: flex;
			justify-content: space-between;
			color: #ffffff;
			margin-bottom: 0px;
		"
	>
		<span translate>メモ</span>

		<!-- <button
			*ngIf="view_mode == 'memo'"
			(click)="changeEditMode()"
			mat-raised-button
			[color]="this.editMode ? 'warn' : 'primary'"
		>
			{{ this.editMode ? "表示" : "編集" }}
		</button> -->
	</h3>
	<h3
		*ngIf="view_mode == 'advice'"
		data-idtest="description-dialog-t-9Kh"
		class="dialog_title"
		mat-dialog-title
		style="
			padding: 16px 0px;
			display: flex;
			justify-content: left;
			font-weight: bold;
			font-size: 30px;
			color: #ffffff;
			margin-bottom: 0px;
		"
	>
		<span translate>AIアドバイス</span>
	</h3>
	<img
		*ngIf="view_mode == 'advice' && device == 'handset'"
		mat-dialog-close=""
		src="/icons/close.png"
		style="
			width: 18px;
			height: 22px;
			cursor: pointer;
			position: absolute;
			top: 32px;
			right: 30px;
		"
	/>
	<button
		*ngIf="view_mode == 'advice' && device != 'handset'"
		color="warn"
		mat-dialog-close=""
		mat-raised-button
		style="cursor: pointer; position: absolute; top: 32px; right: 30px"
	>
		閉じる
	</button>

	<div class="dialog_text"></div>

	<!-- mode = advice -->
	<mat-dialog-content
		*ngIf="view_mode == 'advice'"
		[class]="
			'description-mat-dialog-content-advice ' +
			(view_mode == 'advice' && device == 'handset' ? 'mdc-handset' : '')
		"
	>
		<div fxLayout="row" *ngIf="isViewPC()">
			<div
				fxFlex="50"
				style="padding-right: 10px"
				[style.paddingTop]="this.isMobile() ? '12px' : '10px'"
			>
				<aigia-shot
					[data]="data.shot"
					[modeviewadvice]="true"
				></aigia-shot>
			</div>
			<div fxFlex="50" style="padding-left: 10px">
				<p
					id="view-advice-content"
					style="
						resize: none;
						white-space: pre-line;
						color: white;
						background-color: rgb(31, 41, 55);
						/* height: calc(
							100svh - 178px - env(safe-area-inset-bottom)
						); */
						outline: none;
						box-shadow: none;
						max-height: 100svh;
						overflow-y: auto;
						line-height: 1.5;
						font-size: 14px;
						margin: 12px 0px 0px;
						padding: 40px;
					"
					[style.height]="getHeightAdvice()"
					[innerHTML]="this.adviceHTML"
				></p>
			</div>
		</div>
		<div fxLayout="row" *ngIf="!isViewPC()" style="justify-content: center">
			<div fxFlex="100">
				<p
					class="scrollable"
					id="view-advice-content"
					style="
						resize: none;
						white-space: pre-line;
						color: white;
						background-color: rgb(31, 41, 55);
						/* height: calc(
							100svh - 100px - env(safe-area-inset-bottom)
						); */
						outline: none;
						box-shadow: none;
						max-height: 100svh;
						overflow-y: auto;
						line-height: 1.5;
						font-size: 14px;
						margin: 12px 0px 0px;
						padding: 40px;
						width: calc(100% - 10px);
					"
					[style.height]="getHeightAdvice()"
					[innerHTML]="this.adviceHTML"
				></p>
			</div>
		</div>
	</mat-dialog-content>

	<!-- mode = memo -->
	<mat-dialog-content
		*ngIf="view_mode == 'memo'"
		[class]="'description-mat-dialog-content-memo'"
	>
		<form #form="ngForm" novalidate>
			<div style="margin: 16px 0; font-size: 14px" fxLayout="column">
				<input
					matInput
					type="text"
					message_field="ngModel"
					[(ngModel)]="advice"
					name="message_field"
					data-idtest="description-dialog-p"
					tabindex="-1"
					style="opacity: 0; pointer-events: none; visibility: hidden"
				/>

				<textarea
					type="text"
					placeholder="メモ*"
					id="edit-advice-content"
					(focus)="this.onTextAreaFocus($event)"
					style="
						resize: none;
						white-space: pre-line;
						color: white;
						background-color: rgb(36, 36, 36);
						height: calc(min(100svh, 690px) - 210px);
						max-height: 100svh;
						overflow-y: auto;
						line-height: 1.5;
						font-size: 14px;
						margin: -25px 0px 10px;
						padding: 0px 5px;
						outline: none;
						border: 1px solid gray;
						border-radius: 5px;
					"
					maxlength="1000"
					[style.height]="getHeightMemo()"
					(change)="handeChangeMemo($event)"
					>{{ this.memo }}</textarea
				>

				<mat-hint style="position: relative; font-size: 11px"
					><span data-idtest="description-dialog-t-9We" translate
						>1000文字まで</span
					></mat-hint
				>
				<!-- <mat-error *ngIf="message_field.errors?.['required'];"><span translate>メモを入力ください</span></mat-error> -->
				<!-- <mat-error *ngIf="message_field.errors?.['maxlength'];"><span translate>長すぎます</span></mat-error> -->
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions
		*ngIf="view_mode == 'memo'"
		fxLayout="row"
		fxLayout.lt-sm="row"
		fxLayoutAlign="space-around"
		fxLayoutGap="0px"
		fxLayoutGap.lt-sm="0px"
	>
		<div fxFlex="50%" fxFlex.lt-sm="50%" fxLayoutAlign="center">
			<button
				[disabled]="isProgress"
				color="warn"
				mat-dialog-close=""
				mat-stroked-button
				fxFlex="50%"
				fxFlex.lt-sm="80%"
			>
				<span data-idtest="description-dialog-t-5Eg" translate
					>キャンセル</span
				>
			</button>
		</div>
		<div fxFlex="50%" fxFlex.lt-sm="50%" fxLayoutAlign="center">
			<button
				(click)="view_mode == 'advice' ? cancel() : saveShotMemo()"
				color="primary"
				mat-raised-button
				fxFlex="50%"
				fxFlex.lt-sm="80%"
			>
				<span data-idtest="description-dialog-t-0Zt" translate
					>更新</span
				>
			</button>
		</div>
	</mat-dialog-actions>
	<!-- <mat-dialog-actions
		*ngIf="view_mode == 'advice' && device != 'handset'"
		fxLayout="row"
		fxLayout.lt-sm="row"
		fxLayoutAlign="space-around"
	>
		<button color="warn" mat-dialog-close="" mat-raised-button>
			閉じる
		</button>
	</mat-dialog-actions> -->
</div>
